// extracted by mini-css-extract-plugin
export default {"clientNameWrapper":"ClientNameRenderer_clientNameWrapper__IlZ2g","clickable":"ClientNameRenderer_clickable__AXs9z"};